import { useSelector } from 'react-redux';
import { ActiveSidebar, getActiveSidebar } from 'store/slices/settingsPageSlice';

import SystemFleetsSidebar from './fleets/SystemFleetsSidebar';
import SystemTeamsSidebar from './teams/SystemTeamsSidebar';
import SystemUsersSidebar from './users/SystemUsersSidebar';
import SystemVehiclesSidebar from './vehicles/SystemVehiclesSidebar';

const SettingsSidebarWrapper = () => {
    const activeSidebar = useSelector(getActiveSidebar);

    switch (activeSidebar) {
        case ActiveSidebar.USERS:
            return <SystemUsersSidebar />;
        case ActiveSidebar.TEAMS:
            return <SystemTeamsSidebar />;
        case ActiveSidebar.FLEETS:
            return <SystemFleetsSidebar />;
        case ActiveSidebar.VEHICLES:
            return <SystemVehiclesSidebar />;
        default:
            return;
    }
};

export default SettingsSidebarWrapper;
